_options$items